<mat-form-field class="form-field">
<mat-label>{{label}}</mat-label>
<mat-select id="ip{{label|stripSpaces}}" [(ngModel)]="value" name="item" [required]="required" [disabled]="readonly" #ip="ngModel" (selectionChange)="selectionChange($event)" attr.aria-label="{{label}}">
  <mat-option *ngFor="let item of possibleValues" [value]="item.id" role="option">
    {{item.value | trimString}}
  </mat-option>
</mat-select>
</mat-form-field>
<validation-errors [control]="ip"></validation-errors>
